import {
  TPartnerDuplicatesContentAction,
  TPartnerDuplicatesContentMessage,
} from 'legacy/lut/components/widgets/public/partnerDuplicates/models'
import { useCallback } from 'react'

import { IPartner, IPartnerDuplicate } from 'clickNgo/entities/partner/models'

export const filterContent =
  (partner: IPartner, searchResult: IPartnerDuplicate) =>
  (element: TPartnerDuplicatesContentAction | TPartnerDuplicatesContentMessage) =>
    element.checkVisibility({ partner, duplicate: searchResult })
